import type { HubspotSyncedField } from "@/types/hubspotForm";
import { COMPETITOR_DEMO_FORM_KEY, DEMO_FORM_KEY } from "./constants";

/** Forms that count as a demo request, keyed by form key, with their PostHog `form` value. */
export const DEMO_FORMS: Record<string, "book_a_demo" | "competitor_page"> = {
  [DEMO_FORM_KEY]: "book_a_demo",
  [COMPETITOR_DEMO_FORM_KEY]: "competitor_page",
};

const EMPLOYEE_RANGE_FIELD = "employee_range";

/**
 * Builds the `demo.requested` properties. `employee_range` is only sent when it
 * matches one of the form's synced HubSpot option values, so the property stays
 * an enum; anything else is dropped and reported in `rejected`.
 */
export function getDemoRequestProperties(
  formKey: string,
  syncedFields: HubspotSyncedField[] | undefined,
  fields: Record<string, unknown>,
): { properties: { form: string; employee_range?: string }; rejected: string[] } | null {
  const form = DEMO_FORMS[formKey];
  if (!form) return null;

  const value = fields[EMPLOYEE_RANGE_FIELD];
  if (value == null || value === "") return { properties: { form }, rejected: [] };

  const field = syncedFields?.find((f) => f.name === EMPLOYEE_RANGE_FIELD);
  const allowed = new Set(field?.options?.filter((option) => !option.disabled).map((option) => option.value));
  if (typeof value === "string" && allowed.has(value)) {
    return { properties: { form, employee_range: value }, rejected: [] };
  }
  return { properties: { form }, rejected: [EMPLOYEE_RANGE_FIELD] };
}
